export default __webpack_public_path__ + "static/media/1.81e5cf60.png";